import { render, staticRenderFns } from "./NewOrderSend.vue?vue&type=template&id=1efd9102&scoped=true&"
import script from "./NewOrderSend.vue?vue&type=script&lang=js&"
export * from "./NewOrderSend.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderSend.vue?vue&type=style&index=0&id=1efd9102&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd9102",
  null
  
)

export default component.exports